export default "__VITE_ASSET__Ch7BRhPN__"